import { z } from 'zod'
import { API_TOKEN_SCOPES } from '../enums'
import { id, optionalDate, requiredText } from './common'

/**
 * A machine token acts *as* an existing user, so `createdById`, notifications and the
 * audit log keep pointing at a real actor. Give an agent its own user rather than
 * reusing a person's, or the journal cannot tell them apart.
 */
export const apiTokenInputSchema = z.object({
  name: requiredText(120, 'שם הטוקן הוא שדה חובה'),
  userId: id(),
  scope: z.enum(API_TOKEN_SCOPES).default('READ_ONLY'),
  expiresAt: optionalDate(),
})

export type ApiTokenInput = z.infer<typeof apiTokenInputSchema>

export type ApiTokenDto = {
  id: string
  name: string
  userId: string
  userName: string | null
  userEmail: string | null
  scope: (typeof API_TOKEN_SCOPES)[number]
  lastUsedAt: string | null
  expiresAt: string | null
  revokedAt: string | null
  createdById: string
  createdByName: string | null
  createdAt: string
}

/** The one and only response that carries the secret — shown once, never stored. */
export type ApiTokenCreatedDto = ApiTokenDto & { token: string }
